module.exports = __webpack_public_path__ + "static/media/Block by Block_20191010_135410626411075.351a1437.jpg";